import React from "react";
import classNames from "classnames";
import { useOCRContext } from "@context/OCRContext";
import { Info } from "@Icons";

const PassportKor = () => {
  const { result } = useOCRContext();
  const ssaResult = result.ocr_result.id_truth === "REAL";

  const expiryDate = result.ocr_result.expiry_date?.replaceAll(".", ". ") || "";

  return (
    <div className="content">
      <ul>
        <li>
          <span className="label">신분증 종류</span>
          <span className="value">여권</span>
        </li>
        <li>
          <span className="label">사본여부</span>
          <span className={classNames("value", ssaResult ? "ssa-true" : "ssa-false")}>
            {ssaResult ? "TRUE" : "FALSE"}
          </span>
        </li>
        <li>
          <span className="label">여권 종류</span>
          <span className="value">{result.ocr_result.passport_type}</span>
        </li>
        <li>
          <span className="label">발행국</span>
          <span className="value">{result.ocr_result.issuing_country}</span>
        </li>
        <li>
          <span className="label">여권번호</span>
          <span className="value">{result.ocr_result.passport_number}</span>
        </li>
        <li>
          <span className="label">성명(성)</span>
          <span className="value">{result.ocr_result.sur_name}</span>
        </li>
        <li>
          <span className="label">성명(이름)</span>
          <span className="value">{result.ocr_result.given_name}</span>
        </li>
        <li>
          <span className="label">성별</span>
          <span className="value">{result.ocr_result.sex}</span>
        </li>
        <li>
          <span className="label">생년월일</span>
          <span className="value">{result.ocr_result.birthday}</span>
        </li>
        <li>
          <span className="label">만료일</span>
          <span className="value">{expiryDate}</span>
        </li>
      </ul>
      <div className="info">
        <Info st={{ fontSize: "16px" }} />
        {ssaResult ? (
          <span>
            정보가 맞지 않다면 <b>이전(재촬영)</b>을 눌러 주시고, 정보가 맞으면 <b>다음</b>으로 진행해 주세요.
          </span>
        ) : (
          <span>
            사본으로 확인되었습니다. <b>재촬영</b>해 주세요.
          </span>
        )}
      </div>
    </div>
  );
};
export default PassportKor;
